exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".edit {\n    color: var(--medici-color-primary);\n}\n", ""]);

// exports
